import { User } from '@prisma/client'
import { Form, Typography } from 'antd'
import React from 'react'
import { CommonClient } from '~/agents/common/client'
import { TitlePrimary } from '~/features/shared/components'
import { LabelPicker } from '../../components/LabelPicker'
import { LABEL_SUGGESTIONS } from '../../objects'
import { StepProps } from '../types'

type Props = {
  user: User
} & StepProps

export const StepLabels: React.FC<Props> = ({ user, ...props }) => {
  return (
    <>
      <CommonClient.Onboarding.Step {...props}>
        <TitlePrimary level={4} style={{ marginBottom: '32px' }}>
          How do you want me to categorize your emails?
        </TitlePrimary>

        <Typography.Text type="secondary" className="mb-10">
          I can categorize your emails into different labels. You can choose
          from the suggestions below or create your own.
        </Typography.Text>

        <Form.Item
          name={['labels']}
          rules={[
            {
              required: true,
              message: 'Please enter at least one label to continue',
            },
          ]}
        >
          <LabelPicker suggestions={LABEL_SUGGESTIONS} />
        </Form.Item>
      </CommonClient.Onboarding.Step>
    </>
  )
}
